var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",class:{'sidebar--closable' : _vm.closable, 'sidebar--open' : true}},[(_vm.closable)?_c('i',{staticClass:"iconop-close close-sidebar",on:{"click":_vm.close}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }